import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import autoTable from "jspdf-autotable";
import robotIcon from "../robot.png"; // ✅ correct path

// EVE Technology Background Component
function EVEBackground() {
  const toggleMenu = () => {
    const nav = document.querySelector(".nav-links");
    if (!nav) return;
    nav.style.display = nav.style.display === "flex" ? "none" : "flex";
    nav.style.flexDirection = "column";
    nav.style.background = "rgba(11,18,32,.98)";
    nav.style.position = "absolute";
    nav.style.top = "60px";
    nav.style.right = "20px";
    nav.style.padding = "16px";
    nav.style.gap = "12px";
    nav.style.border = "1px solid rgba(255,255,255,.08)";
    nav.style.borderRadius = "12px";
  };

  const submitDemo = (e) => {
    e.preventDefault();
    alert("Thanks! Our team will contact you shortly.");
    e.target.reset();
  };

  return (
    <div
      className="w-full h-auto"
      style={{
        font: '16px/1.6 system-ui, -apple-system, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", Arial, sans-serif',
        background:
          "radial-gradient(1200px 600px at 80% -10%, rgba(36, 225, 164, 0.12), transparent), radial-gradient(1000px 600px at -10% 10%, rgba(11, 105, 255, 0.18), transparent), #0b1220",
        color: "#e7edff",
      }}
    >
      <style>{`
        .eve-container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        .eve-nav { display: flex; align-items: center; justify-content: space-between; padding: 14px 0; }
        .eve-brand { display: flex; align-items: center; gap: 10px; font-weight: 800; letter-spacing: 0.3px; }
        .eve-logo { width: 36px; height: 36px; border-radius: 10px; background: linear-gradient(135deg, #0b69ff, #5b8dff); box-shadow: 0 10px 30px rgba(11, 105, 255, 0.25); display: grid; place-items: center; color: #fff; font-weight: 900; }
        .eve-nav-links { display: flex; gap: 22px; align-items: center; }
        .eve-nav-links a { color: #e7edff; opacity: 0.85; text-decoration: none; }
        .eve-btn { display: inline-flex; align-items: center; gap: 10px; border: 0; border-radius: 12px; padding: 12px 16px; font-weight: 700; cursor: pointer; transition: 0.2s transform, 0.2s box-shadow; text-decoration: none; }
        .eve-btn:hover { transform: translateY(-1px); }
        .eve-btn.primary { background: linear-gradient(135deg, #0b69ff, #5b8dff); color: #fff; box-shadow: 0 10px 30px rgba(11, 105, 255, 0.25); }
        .eve-btn.ghost { border: 1px solid rgba(255, 255, 255, 0.12); color: #e7edff; background: transparent; }
        .eve-menu { display: none; }
        .eve-hero { padding: 84px 0 40px; }
        .eve-grid-hero { display: grid; grid-template-columns: 1.1fr 0.9fr; gap: 30px; align-items: center; }
        .eve-eyebrow { color: #24e1a4; font-weight: 800; letter-spacing: 0.2em; text-transform: uppercase; font-size: 12px; }
        .eve-h1 { font-size: 48px; line-height: 1.1; margin: 0.3em 0 0.4em; }
        .eve-lead { color: #a9b6d5; font-size: 18px; }
        .eve-cta { margin-top: 24px; display: flex; gap: 12px; flex-wrap: wrap; }
        .eve-card { background: linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02)); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 14px; padding: 20px; }
        .eve-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; margin-top: 22px; }
        .eve-stat { background: rgba(11, 105, 255, 0.09); border: 1px solid rgba(11, 105, 255, 0.22); }
        .eve-panel { padding: 28px; margin-top: 20px; }
        .eve-tag { display: inline-block; padding: 6px 10px; border: 1px solid rgba(255, 255, 255, 0.12); border-radius: 999px; font-size: 12px; color: #a9b6d5; margin: 6px 6px 0 0; }
        .eve-section { padding: 56px 0; }
        .eve-section h2 { font-size: 34px; margin: 0.2em 0 0.2em; }
        .eve-muted { color: #a9b6d5; }
        .eve-features { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-top: 18px; }
        .eve-feature { padding: 20px; }
        .eve-feature h3 { margin: 0.4em 0; font-size: 18px; }
        .eve-kicker { font-weight: 800; color: #9fe6cc; text-transform: uppercase; font-size: 12px; letter-spacing: 0.2em; }
        .eve-showcase { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; margin-top: 18px; }
        .eve-shot { aspect-ratio: 16/10; border-radius: 14px; background: linear-gradient(120deg, rgba(36, 225, 164, 0.2), rgba(11, 105, 255, 0.16)); border: 1px solid rgba(255, 255, 255, 0.08); }
        .eve-cta-bar { display: flex; gap: 14px; align-items: center; justify-content: space-between; flex-wrap: wrap; }
        .eve-logos { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; margin-top: 18px; opacity: 0.8; }
        .eve-logos div { height: 42px; border: 1px dashed rgba(255, 255, 255, 0.12); border-radius: 10px; display: grid; place-items: center; font-size: 12px; color: #a9b6d5; }
        .eve-faq { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 18px; }
        .eve-faq details { border: 1px solid rgba(255, 255, 255, 0.12); border-radius: 12px; padding: 16px; background: rgba(255, 255, 255, 0.03); }
        .eve-faq summary { cursor: pointer; font-weight: 700; }
        .eve-contact { display: grid; grid-template-columns: 1fr 0.9fr; gap: 20px; margin-top: 18px; }
        .eve-form { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .eve-label { font-size: 12px; color: #a9b6d5; }
        .eve-input, .eve-textarea, .eve-select { width: 100%; padding: 12px 14px; border-radius: 12px; border: 1px solid rgba(255, 255, 255, 0.12); background: #0c1526; color: #e7edff; }
        .eve-textarea { min-height: 120px; grid-column: 1/-1; resize: vertical; }
        .eve-full { grid-column: 1/-1; }
        .eve-footer { padding: 36px 0; border-top: 1px solid rgba(255, 255, 255, 0.06); color: #a9b6d5; }
        .eve-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 22px; }
        .eve-footer-grid h4 { color: #e7edff; }
        .eve-copyright { margin-top: 18px; font-size: 13px; }
        @media (max-width: 980px) {
          .eve-grid-hero { grid-template-columns: 1fr; }
          .eve-features { grid-template-columns: 1fr 1fr; }
          .eve-showcase { grid-template-columns: 1fr; }
          .eve-faq { grid-template-columns: 1fr; }
          .eve-contact { grid-template-columns: 1fr; }
          .eve-footer-grid { grid-template-columns: 1fr 1fr; }
          .eve-nav-links { display: none; }
          .eve-menu { display: inline-flex; }
        }
        @media (max-width: 560px) {
          .eve-h1 { font-size: 36px; }
          .eve-features { grid-template-columns: 1fr; }
          .eve-footer-grid { grid-template-columns: 1fr; }
          .eve-stats { grid-template-columns: 1fr; }
        }
      `}</style>

      <header
        style={{
          position: "sticky",
          top: 0,
          background: "rgba(11, 18, 32, 0.7)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
          zIndex: 50,
        }}
      >
        <div className="eve-container eve-nav">
          <a className="eve-brand" href="#" aria-label="EVE Technology Home">
            <div className="eve-logo">E</div>
            <span>EVE Technology</span>
          </a>
          <nav className="eve-nav-links" aria-label="Primary">
            <a href="#features">Features</a>
            <a href="#solutions">Solutions</a>
            <a href="#showcase">Product</a>
            <a href="#faq">FAQ</a>
            <a href="#contact">Contact</a>
            <a href="mailto:info@eve24hrs.com" className="eve-btn ghost">
              Request a Demo
            </a>
          </nav>
          <button
            className="eve-btn ghost eve-menu"
            aria-label="Open Menu"
            onClick={toggleMenu}
          >
            ☰
          </button>
        </div>
      </header>

      <main>
        <section className="eve-hero">
          <div className="eve-container eve-grid-hero">
            <div>
              <div className="eve-eyebrow">All-in-one business OS</div>
              <h1 className="eve-h1">
                HRMS, Payroll, Sales Automation & Field Force — in a single
                platform
              </h1>
              <p className="eve-lead">
                Run your organization end‑to‑end with EVE Technology: automate
                payroll, manage HR, track field teams with GPS, and accelerate
                revenue with sales automation & dashboards.
              </p>
              <div className="eve-cta">
                <a href="#contact" className="eve-btn primary">
                  Get a Demo
                </a>
                <a href="https://www.eve24hrs.com/" className="eve-btn ghost">
                  Explore Full Site ↗
                </a>
              </div>
              <div className="eve-stats">
                <div className="eve-card eve-stat">
                  <strong>Payroll</strong>
                  <br />
                  <span className="eve-muted">
                    Automated TDS, payslips & F&F
                  </span>
                </div>
                <div className="eve-card eve-stat">
                  <strong>Field Teams</strong>
                  <br />
                  <span className="eve-muted">GPS tracking & geofencing</span>
                </div>
                <div className="eve-card eve-stat">
                  <strong>Sales</strong>
                  <br />
                  <span className="eve-muted">Leads → Quotes → Invoices</span>
                </div>
              </div>
            </div>
            <div>
              <div className="eve-card eve-panel">
                <div className="eve-kicker">Quick overview</div>
                <p className="eve-muted">
                  Modules you can enable as you grow. No bloat.
                </p>
                <div>
                  {[
                    "HRMS",
                    "Payroll",
                    "Time & Attendance",
                    "Shifts & Rosters",
                    "Recruitment",
                    "PMS / KPI",
                    "Sales Automation",
                    "Sales Force Mgmt",
                    "GPS Tracking",
                    "Reports & Dashboards",
                    "Quotations & Invoices",
                    "Renewals & Payments",
                  ].map((tag, i) => (
                    <span key={i} className="eve-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="features" className="eve-section">
          <div className="eve-container">
            <h2>Everything you need to run HR, Sales & Operations</h2>
            <p className="eve-muted">
              Pick the modules you need today. Add more tomorrow.
            </p>
            <div className="eve-features">
              <div className="eve-card eve-feature">
                <h3>HRMS</h3>
                <p className="eve-muted">
                  Employee database, policies & hierarchy, documents, KYC &
                  notices.
                </p>
              </div>
              <div className="eve-card eve-feature">
                <h3>Payroll</h3>
                <p className="eve-muted">
                  Automated payroll & TDS, loans & advances, gratuity and F&F.
                </p>
              </div>
              <div className="eve-card eve-feature">
                <h3>Time & Attendance</h3>
                <p className="eve-muted">
                  Shifts & rosters, overtime, comp‑off, leave & bonus
                  management.
                </p>
              </div>
              <div className="eve-card eve-feature">
                <h3>Sales Automation</h3>
                <p className="eve-muted">
                  Leads, pipeline, proposals & quotations, renewals, payments.
                </p>
              </div>
              <div className="eve-card eve-feature">
                <h3>Sales Force Management</h3>
                <p className="eve-muted">
                  Targets & teams, client tasks, calls, emails & meeting
                  minutes.
                </p>
              </div>
              <div className="eve-card eve-feature">
                <h3>Employee GPS Tracking</h3>
                <p className="eve-muted">
                  Geo‑fencing, mapped routes and real‑time team visibility.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="solutions" className="eve-section">
          <div className="eve-container">
            <div className="eve-cta-bar eve-card">
              <div>
                <h2>Built for white‑collar and blue‑collar teams</h2>
                <p className="eve-muted">
                  Supervisor access, worker shifts, bench worker management and
                  daily wage slips — alongside PMS, KPI and appraisal workflows.
                </p>
              </div>
              <a
                href="https://www.eve24hrs.com/pricing"
                className="eve-btn primary"
              >
                See Pricing ↗
              </a>
            </div>
          </div>
        </section>

        <section id="showcase" className="eve-section">
          <div className="eve-container">
            <h2>Dashboards & Reports</h2>
            <p className="eve-muted">
              Unified analytics across HR, sales and finance help you decide
              faster.
            </p>
            <div className="eve-showcase">
              <div className="eve-shot"></div>
              <div className="eve-shot"></div>
            </div>
            <div className="eve-logos">
              <div>Your Logo</div>
              <div>Grows Here</div>
              <div>Trusted By</div>
              <div>Real Teams</div>
              <div>Across India</div>
            </div>
          </div>
        </section>

        <section id="faq" className="eve-section">
          <div className="eve-container">
            <h2>Frequently asked questions</h2>
            <div className="eve-faq">
              <details>
                <summary>Can I start with HRMS and add Payroll later?</summary>
                <p className="eve-muted">
                  Yes. EVE is modular — enable only the pieces you need and
                  expand anytime.
                </p>
              </details>
              <details>
                <summary>Do you support GPS tracking for field teams?</summary>
                <p className="eve-muted">
                  Absolutely. Real‑time location, geo‑fencing, mapped routes and
                  attendance.
                </p>
              </details>
              <details>
                <summary>Is EVE suitable for blue‑collar workforces?</summary>
                <p className="eve-muted">
                  Yes. Supervisor access, roster & shift planning, overtime and
                  wage slips are built‑in.
                </p>
              </details>
              <details>
                <summary>How do I get a quote?</summary>
                <p className="eve-muted">
                  Use the contact form below or email{" "}
                  <a href="mailto:info@eve24hrs.com">info@eve24hrs.com</a> and
                  our team will tailor a plan.
                </p>
              </details>
            </div>
          </div>
        </section>

        <section id="contact" className="eve-section">
          <div className="eve-container eve-contact">
            <div>
              <h2>Let's get you a personalised demo</h2>
              <p className="eve-muted">
                Share a few details and we'll reach out with the best setup for
                your business.
              </p>
              <form className="eve-form" onSubmit={submitDemo}>
                <div>
                  <label className="eve-label">First Name</label>
                  <input className="eve-input" placeholder="Jane" required />
                </div>
                <div>
                  <label className="eve-label">Last Name</label>
                  <input className="eve-input" placeholder="Doe" required />
                </div>
                <div>
                  <label className="eve-label">Work Email</label>
                  <input
                    className="eve-input"
                    type="email"
                    placeholder="you@company.com"
                    required
                  />
                </div>
                <div>
                  <label className="eve-label">Phone</label>
                  <input className="eve-input" type="tel" placeholder="+91" />
                </div>
                <div className="eve-full">
                  <label className="eve-label">Company</label>
                  <input
                    className="eve-input"
                    placeholder="Your Organization"
                    required
                  />
                </div>
                <div>
                  <label className="eve-label">Employees</label>
                  <select className="eve-select">
                    <option value="1-20">1–20</option>
                    <option value="21-100">21–100</option>
                    <option value="101-500">101–500</option>
                    <option value=">500">500+</option>
                  </select>
                </div>
                <div>
                  <label className="eve-label">Sector</label>
                  <input
                    className="eve-input"
                    placeholder="e.g. Manufacturing, IT, Services"
                  />
                </div>
                <div className="eve-full">
                  <label className="eve-label">
                    What would you like to solve first?
                  </label>
                  <textarea
                    className="eve-textarea"
                    placeholder="Payroll, Field Force tracking, Sales pipeline…"
                  ></textarea>
                </div>
                <div className="eve-full">
                  <button className="eve-btn primary" type="submit">
                    Request a Demo
                  </button>
                  <a className="eve-btn ghost" href="mailto:info@eve24hrs.com">
                    Email us instead
                  </a>
                </div>
              </form>
            </div>
            <div className="eve-card">
              <h3>Quick links</h3>
              <p className="eve-muted">
                Explore detailed pages on our main site while EVEtechnology.in
                goes live.
              </p>
              <ul>
                <li>
                  <a href="https://www.eve24hrs.com/hrms-software">
                    HRMS Software
                  </a>
                </li>
                <li>
                  <a href="https://www.eve24hrs.com/hr-payroll-software">
                    HR Payroll Software
                  </a>
                </li>
                <li>
                  <a href="https://www.eve24hrs.com/sales-automation-software">
                    Sales Automation
                  </a>
                </li>
                <li>
                  <a href="https://www.eve24hrs.com/employee-gps-tracking-software">
                    Employee GPS Tracking
                  </a>
                </li>
                <li>
                  <a href="https://www.eve24hrs.com/pricing">Plans & Pricing</a>
                </li>
                <li>
                  <a href="https://www.eve24hrs.com/faq">FAQ</a>
                </li>
              </ul>
              <div className="eve-card" style={{ marginTop: "16px" }}>
                <div className="eve-kicker">Support</div>
                <p>
                  Email <a href="mailto:info@eve24hrs.com">info@eve24hrs.com</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="eve-footer">
        <div className="eve-container eve-footer-grid">
          <div>
            <div className="eve-brand">
              <div className="eve-logo">E</div>
              <span>EVE Technology</span>
            </div>
            <p className="eve-muted">
              Manage HR, payroll, sales and field teams with a single, modular
              platform.
            </p>
            <p className="eve-copyright">
              © {new Date().getFullYear()} EVE Technologies Pvt. Ltd. All rights
              reserved.
            </p>
          </div>
          <div>
            <h4>Company</h4>
            <a href="https://www.eve24hrs.com/about-us">About</a>
            <br />
            <a href="https://www.eve24hrs.com/blog/">Blog</a>
            <br />
            <a href="#contact">Contact</a>
          </div>
          <div>
            <h4>Product</h4>
            <a href="#features">Features</a>
            <br />
            <a href="#showcase">Reports</a>
            <br />
            <a href="https://www.eve24hrs.com/pricing">Pricing</a>
          </div>
          <div>
            <h4>Legal</h4>
            <a href="https://www.eve24hrs.com/privacy-policy">Privacy</a>
            <br />
            <a href="https://www.eve24hrs.com/faq">FAQ</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Export to PDF
const exportToPDF = (headers, rows, fileName = "report.pdf") => {
  const doc = new jsPDF();
  doc.text("EVE Assistant Report", 14, 15);
  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: 25,
    theme: "grid",
    headStyles: {
      fillColor: [0, 188, 212],
      textColor: 255,
      halign: "center",
    },
    bodyStyles: { halign: "center" },
    alternateRowStyles: { fillColor: [245, 245, 245] },
  });
  doc.save(fileName);
};

// Export to Excel
const exportToExcel = (headers, rows, fileName = "report.xlsx") => {
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

// Contact Form Component
function ContactForm({ onSubmitContact }) {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email && formData.phone) {
      onSubmitContact(formData);
    }
  };

  return (
    <div className="glass-message rounded-xl p-4 shadow-lg max-w-full animate-slideUpFade">
      <h3 className="font-bold text-gray-800 text-lg mb-3">Contact Details</h3>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-cyan-500"
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-cyan-500"
          required
        />
        <input
          type="tel"
          placeholder="Your Phone Number"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-cyan-500"
          required
        />
        <button
          type="submit"
          className="w-full px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-lg hover:opacity-90 transition-all"
        >
          Submit Details
        </button>
      </form>
    </div>
  );
}

// Products & Services Component
function ProductsServices({ onProductClick }) {
  const [isExpanded, setIsExpanded] = useState(true);

  const products = [
    {
      name: "FOS",
      icon: "📊",
      desc: "Feets on Street / Sales Tracker",
      colorClass: "product-card-blue",
    },
    {
      name: "White Collar HRMS",
      icon: "👔",
      desc: "Executive HR Management",
      colorClass: "product-card-purple",
    },
    {
      name: "Blue Collar HRMS",
      icon: "🔧",
      desc: "Field Worker Management",
      colorClass: "product-card-emerald",
    },
    {
      name: "PMS",
      icon: "📈",
      desc: "Project Management System",
      colorClass: "product-card-orange",
    },
    {
      name: "SATURN",
      icon: "🪐",
      desc: "Sales Activity Tracker & Unique Reporting Network",
      colorClass: "product-card-indigo",
    },
  ];

  return (
    <div className="glass-message rounded-xl p-4 shadow-lg max-w-full">
      <div
        className="flex items-center justify-between cursor-pointer mb-3"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <span className="text-lg">⚡</span>
          <span className="font-semibold text-gray-700">
            Products and Services
          </span>
        </div>
        <span
          className={`dropdown-toggle text-gray-500 ${
            isExpanded ? "open" : ""
          }`}
        >
          ▾
        </span>
      </div>

      {isExpanded && (
        <div className="products-grid animate-slideUpFade">
          {products.map((product, idx) => (
            <div
              key={idx}
              className={`product-grid-card ${product.colorClass}`}
              onClick={() => onProductClick(product.name)}
            >
              <div className="text-2xl mb-2">{product.icon}</div>
              <div className="text-sm font-medium text-gray-700">
                {product.name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Table Pagination
function TableWithPagination({ headers, rows }) {
  const [page, setPage] = useState(0);
  const pageSize = 10;
  const start = page * pageSize;
  const end = start + pageSize;
  const paginatedRows = rows.slice(start, end);

  return (
    <div>
      <table className="min-w-full border border-gray-700 text-sm rounded-lg overflow-hidden">
        <thead className="bg-cyan-700 text-white">
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className="px-3 py-2 border border-gray-700 text-left font-semibold"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedRows.map((row, ri) => (
            <tr
              key={ri}
              className={ri % 2 === 0 ? "bg-[#1e1f25]" : "bg-[#2a2b32]"}
            >
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  className="px-3 py-2 border border-gray-700 text-gray-300"
                >
                  {cell ?? "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length > pageSize && (
        <div className="flex justify-between items-center mt-3">
          <button
            onClick={() => setPage((p) => Math.max(p - 1, 0))}
            disabled={page === 0}
            className="px-3 py-1 bg-cyan-600 text-white rounded disabled:opacity-50"
          >
            Prev
          </button>
          <span className="text-gray-400 text-sm">
            Page {page + 1} of {Math.ceil(rows.length / pageSize)}
          </span>
          <button
            onClick={() => setPage((p) => (end < rows.length ? p + 1 : p))}
            disabled={end >= rows.length}
            className="px-3 py-1 bg-cyan-600 text-white rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default function EveChat({ embedMode }) {
  const isOpen = true;
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [chats, setChats] = useState([
    { id: Date.now(), title: "New Chat", messages: [] },
  ]);
  const [activeChatId, setActiveChatId] = useState(chats[0].id);
  const [inputMessage, setInputMessage] = useState("");
  const [botTyping, setBotTyping] = useState(false);
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);
  const msgEndRef = useRef(null);
  const activeChat = chats.find((c) => c.id === activeChatId);

  // Greetings
  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning! 🌅";
    if (hour < 18) return "Good Afternoon! ☀️";
    return "Good Evening! 🌙";
  };

  const getRandomGreeting = () => {
    const greetings = [
      "How can I assist you today?",
      "How may I assist you with EVE today?",
      "What would you like to explore in EVE today?",
      "Need help with something specific on EVE?",
      "How can I make your EVE experience smoother today?",
      "What can I guide you through on EVE right now?",
      "Is there anything you'd like to do in EVE today?",
      "How can I support your tasks on EVE today?",
      "What would you like to manage or learn about in EVE?",
      "I’m here to help — what brings you to EVE today?",
      "Ready to get started with EVE? How can I assist?",
    ];
    return greetings[Math.floor(Math.random() * greetings.length)];
  };

  const addGreetingsToChat = (chatId) => {
    const greeting1 = getTimeBasedGreeting();
    const greeting2 = getRandomGreeting();
    setChats((prev) =>
      prev.map((chat) =>
        chat.id === chatId
          ? {
              ...chat,
              messages: [...chat.messages, { sender: "bot", msg: greeting1 }],
            }
          : chat
      )
    );
    setTimeout(() => {
      setChats((prev) =>
        prev.map((chat) =>
          chat.id === chatId
            ? {
                ...chat,
                messages: [...chat.messages, { sender: "bot", msg: greeting2 }],
              }
            : chat
        )
      );
    }, 2000);
  };

  useEffect(() => {
    if (isOpen && activeChat.messages.length === 0)
      addGreetingsToChat(activeChatId);
  }, [isOpen]);

  useEffect(() => {
    msgEndRef.current?.scrollIntoView({ behavior: "smooth" });
    setShowScrollDown(false);
  }, [activeChat?.messages]);

  useEffect(() => {
    setShowScrollDown(false);
  }, []);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isAtBottom = scrollHeight - scrollTop - clientHeight < 10;
    setShowScrollDown(!isAtBottom && scrollHeight > clientHeight);
  };

  const scrollToBottom = () => {
    msgEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Speech Recognition Setup
  useEffect(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;

    const rec = new SR();
    rec.lang = "en-US";
    rec.continuous = false;
    rec.interimResults = true;

    rec.onstart = () => setListening(true);
    rec.onend = () => setListening(false);
    rec.onerror = () => setListening(false);

    let silenceTimer;

    rec.onresult = async (e) => {
      clearTimeout(silenceTimer);
      let transcript = "";
      for (let i = 0; i < e.results.length; i++) {
        transcript += e.results[i][0].transcript;
      }
      transcript = transcript.trim();
      setInputMessage(transcript);

      const last = e.results[e.results.length - 1];
      if (last?.isFinal && transcript) {
        await sendMessage(transcript);
        try {
          rec.stop();
        } catch {}
      } else {
        silenceTimer = setTimeout(() => {
          if (transcript) sendMessage(transcript);
          try {
            rec.stop();
          } catch {}
        }, 1000);
      }
    };

    recognitionRef.current = rec;
    return () => {
      try {
        rec.abort();
      } catch {}
    };
  }, []);

  const toggleMic = () => {
    const rec = recognitionRef.current;
    if (!rec) {
      addMessage("bot", "🎤 Voice input isn't supported in this browser.");
      return;
    }
    if (listening) rec.stop();
    else rec.start();
  };

  const addMessage = (sender, msg) => {
    setChats((prev) =>
      prev.map((chat) =>
        chat.id === activeChatId
          ? { ...chat, messages: [...chat.messages, { sender, msg }] }
          : chat
      )
    );
  };

  const handleContactSubmit = async (contactData) => {
    try {
      const sessionId = getUserSessionId();
      const res = await fetch(
        `${process.env.REACT_APP_RASA_SERVER_URL}/webhooks/rest/webhook`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sender: sessionId,
            message: `/save_contact{"contact_name":"${contactData.name}","contact_email":"${contactData.email}","contact_phone":"${contactData.phone}"}`,
          }),
        }
      );
      const data = await res.json();
      if (Array.isArray(data)) {
        data.forEach((temp) => {
          if (temp.text) addMessage("bot", temp.text);
        });
      }
    } catch (error) {
      addMessage(
        "bot",
        "Sorry, there was an error saving your details. Please try again."
      );
    }
  };

  const renderMessageWithMarkdown = (message) => {
    if (typeof message !== "string") return message;
    const lines = message.split("\n");
    const elements = [];

    lines.forEach((line, lineIndex) => {
      const trimmed = line.trim();

      // Skip standalone bullet symbols
      if (trimmed === "•") {
        return;
      }

      // Handle bullet points
      if (trimmed.startsWith("* ")) {
        const bulletText = trimmed.replace(/^\*\s*/, "");
        elements.push(
          <div
            key={`bullet-${lineIndex}`}
            className="flex items-start gap-2 mb-2"
          >
            <span className="text-blue-500 mt-1 flex-shrink-0">•</span>
            <span className="flex-1">
              {renderTextWithFormatting(bulletText)}
            </span>
          </div>
        );
      } else if (trimmed) {
        elements.push(
          <div key={`line-${lineIndex}`} className="mb-2">
            {renderTextWithFormatting(trimmed)}
          </div>
        );
      }
    });

    return elements.length > 0 ? elements : message;
  };

  const renderTextWithFormatting = (text) => {
    // Handle bold text **text**
    const boldRegex = /\*\*([^*]+)\*\*/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = boldRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(renderLinksInText(text.slice(lastIndex, match.index)));
      }
      parts.push(
        <strong key={match.index} className="font-semibold text-white">
          {match[1]}
        </strong>
      );
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      parts.push(renderLinksInText(text.slice(lastIndex)));
    }

    return parts.length > 1 ? parts : renderLinksInText(text);
  };

  const renderLinksInText = (text) => {
    if (typeof text !== "string") return text;

    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }

      // Parse the link text for HTML styling
      const linkText = match[1];
      let linkContent;

      // Check if link text contains HTML span with white color
      if (linkText.includes("<span style='color:white'>")) {
        const spanMatch = linkText.match(
          /<span style='color:white'>([^<]+)<\/span>/
        );
        if (spanMatch) {
          linkContent = <span style={{ color: "white" }}>{spanMatch[1]}</span>;
        } else {
          linkContent = linkText;
        }
      } else {
        linkContent = linkText;
      }

      parts.push(
        <a
          key={match.index}
          href={match[2]}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-gray-200 underline font-medium"
        >
          {linkContent}
        </a>
      );
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts.length > 1 ? parts : text;
  };

  const checkForProductKeywords = (message) => {
    const keywords = [
      "product",
      "service",
      "what do you offer",
      "what can you help",
      "show products",
      "available services",
    ];
    return keywords.some((keyword) => message.toLowerCase().includes(keyword));
  };

  // Generate unique user session ID
  const getUserSessionId = () => {
    let sessionId = localStorage.getItem("eve_session_id");
    if (!sessionId) {
      sessionId = `user_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      localStorage.setItem("eve_session_id", sessionId);
    }
    return sessionId;
  };

  const sendMessage = async (text) => {
    const msg = text.trim();
    if (!msg) return;
    if (msg.length > 2000) {
      addMessage(
        "bot",
        "⚠️ Message too long. Please keep it under 2000 characters."
      );
      return;
    }
    addMessage("user", msg);
    setInputMessage("");
    setBotTyping(true);

    if (checkForProductKeywords(msg)) {
      addMessage("bot", { type: "products" });
      setBotTyping(false);
      return;
    }

    try {
      const sessionId = getUserSessionId();
      const res = await fetch(
        `${process.env.REACT_APP_RASA_SERVER_URL}/webhooks/rest/webhook`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sender: sessionId, message: msg }),
        }
      );
      const data = await res.json();
      if (Array.isArray(data)) {
        data.forEach((temp) => {
          if (temp.custom) addMessage("bot", temp.custom);
          else if (temp.text) {
            if (temp.buttons && temp.buttons.length > 0) {
              // Handle message with buttons
              addMessage("bot", {
                type: "button_message",
                text: temp.text,
                buttons: temp.buttons,
              });
            } else {
              addMessage("bot", temp.text);
            }
          }
        });
      }
    } catch {
      addMessage(
        "bot",
        <span>
          Our Eve Chat service is available Monday to Saturday, from 9 AM to 9
          PM. For assistance outside these hours, please{" "}
          <a
            href="https://www.eve24hrs.com/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 underline font-medium"
          >
            click here
          </a>{" "}
          to contact our customer care team.
        </span>
      );
    } finally {
      setBotTyping(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await sendMessage(inputMessage);
  };

  const handleHeaderClose = () => {
    window.parent.postMessage(
      {
        type: "chatbot-toggle",
        open: false,
        height: "80px",
      },
      "*"
    );

    window.parent.postMessage(
      {
        type: "EVE_CHAT_CLOSE",
        source: "eve-chat-iframe",
        timestamp: Date.now(),
      },
      "*"
    );
  };

  useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          type: "EVE_CHAT_READY",
          source: "eve-chat-iframe",
        },
        "*"
      );
    }
  }, []);

  return (
    <div
      className="w-full h-[100dvh] bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800"
    >
      {/* <EVEBackground /> */}

      {/* 💬 Professional Chat Window */}
      {isOpen && (
        <div className="w-full h-full p-0 md:p-4 lg:p-6 flex">
          <div className="chatbot-window w-full h-full md:max-w-5xl md:mx-auto md:h-[calc(100dvh-2rem)] lg:h-[calc(100dvh-3rem)] rounded-none md:rounded-2xl bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md border-0 md:border border-gray-600/50 shadow-none md:shadow-2xl flex flex-col overflow-hidden animate-windowsOpen">
          {/* Professional Header */}
          <div className="flex justify-between items-center p-3 gradient-primary text-white border-b border-white/10 rounded-t-2xl">
            <div className="flex items-center gap-3">
              <div className="relative">
                <img
                  src={robotIcon}
                  alt="EVE Robot"
                  className="w-[65px] h-[65px] rounded-full border-2 border-white/20"
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-pulse border-2 border-white"></div>
              </div>
              <span className="">
                <div className="flex items-center gap-2 relative">
                  <h1 className="font-bold text-[1.7rem] tracking-wide text-start">
                    EVE Chat-E
                  </h1>
                  <span className="px-1 py-[3px] bg-blue-500/20 text-md font-bold text-blue-200 absolute top-[-10px] left-[148px] animate-pulse">
                    beta
                  </span>
                </div>
                <h3 className="font-bold text-sm tracking-wide -mt-1 italic">
                  Powered by EVE Technology Pvt. Ltd.
                </h3>
              </span>
            </div>
            <button
              onClick={handleHeaderClose}
              type="button"
              aria-label="Close chat"
              title="Close chat"
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-200 hover:rotate-90"
            >
              <span className="text-sm leading-none">✕</span>
            </button>
          </div>

          {/* Professional Chat Body */}
          <div
            onScroll={handleScroll}
            className="flex-1 overflow-y-auto px-6 py-6 space-y-4 glass-secondary relative"
          >
            {activeChat?.messages.map((m, idx) => {
              const isUser = m.sender === "user";
              if (m.msg && typeof m.msg === "object") {
                if (m.msg.type === "table") {
                  return (
                    <div
                      key={idx}
                      className="flex justify-start animate-slideUpFade"
                    >
                      <div className="glass-message rounded-xl p-5 shadow-lg max-w-full">
                        <TableWithPagination
                          headers={m.msg.headers}
                          rows={m.msg.rows}
                        />
                        <div className="flex gap-2 mt-4">
                          <button
                            onClick={() =>
                              exportToPDF(
                                m.msg.headers,
                                m.msg.rows,
                                "eve-report.pdf"
                              )
                            }
                            className="px-4 py-2 gradient-primary hover:opacity-90 rounded-lg text-sm text-white font-medium transition-all"
                          >
                            📄 PDF
                          </button>
                          <button
                            onClick={() =>
                              exportToExcel(
                                m.msg.headers,
                                m.msg.rows,
                                "eve-report.xlsx"
                              )
                            }
                            className="px-4 py-2 gradient-secondary hover:opacity-90 rounded-lg text-sm text-white font-medium transition-all"
                          >
                            📊 Excel
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }
                if (m.msg.type === "products") {
                  return (
                    <div
                      key={idx}
                      className="flex justify-start animate-slideUpFade"
                    >
                      <ProductsServices onProductClick={sendMessage} />
                    </div>
                  );
                }
                if (m.msg.type === "button_message") {
                  return (
                    <div
                      key={idx}
                      className="flex justify-start animate-slideUpFade"
                    >
                      <div className="glass-message rounded-xl p-4 shadow-lg max-w-full">
                        <div className="mb-3 text-gray-700">{m.msg.text}</div>
                        {m.msg.buttons.map((button, btnIdx) => (
                          <button
                            key={btnIdx}
                            onClick={() => sendMessage(button.payload)}
                            className="px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:opacity-90 transition-all mr-2"
                          >
                            {button.title}
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                }
                if (m.msg.type === "contact_form") {
                  return (
                    <div
                      key={idx}
                      className="flex justify-start animate-slideUpFade"
                    >
                      <ContactForm onSubmitContact={handleContactSubmit} />
                    </div>
                  );
                }
              }
              return (
                <div
                  key={idx}
                  className={`flex ${
                    isUser ? "justify-end" : "justify-start"
                  } animate-slideUpFade`}
                >
                  <div
                    className={`max-w-[380px] px-4 py-3 rounded-xl text-sm leading-relaxed shadow-lg text-left ${
                      isUser ? "user-message text-white" : "bot-message"
                    }`}
                  >
                    {isUser ? m.msg : renderMessageWithMarkdown(m.msg)}
                  </div>
                </div>
              );
            })}
            {botTyping && (
              <div className="flex justify-start animate-slideUpFade">
                <div className="glass-message px-4 py-3 rounded-xl text-gray-600 typing-indicator">
                  EVE is thinking
                </div>
              </div>
            )}
            <div ref={msgEndRef} />
          </div>

          {showScrollDown && (
            <button
              onClick={scrollToBottom}
              className="absolute bottom-20 right-4 w-10 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-200 z-20"
            >
              ↓
            </button>
          )}

          {/* Professional Input Bar */}
          <div className="border-t border-gray-200 glass-secondary p-3 rounded-b-2xl">
            <form onSubmit={handleSubmit} className="flex items-center gap-2">
              <div className="flex-1 relative">
                <input
                  type="text"
                  value={inputMessage}
                  onChange={(e) => setInputMessage(e.target.value)}
                  placeholder="Type your message..."
                  className="w-full px-4 py-2 rounded-xl bg-white border border-gray-300 text-gray-700 placeholder-gray-500 focus:outline-none input-professional text-sm"
                />
              </div>
              <button
                type="button"
                onClick={toggleMic}
                className={`p-2 rounded-xl transition-all duration-200 ${
                  listening
                    ? "bg-red-500 hover:bg-red-600 animate-pulse"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
              >
                <span className="text-gray-700 text-sm">
                  {listening ? "🔴" : "🎤"}
                </span>
              </button>
              <button
                type="submit"
                disabled={!inputMessage.trim()}
                className="px-3 py-2 gradient-primary hover:opacity-90 rounded-lg text-white font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed text-xs"
              >
                Send
              </button>
            </form>
          </div>
        </div>
        </div>
      )}
    </div>
  );
}
